import { RingingDevice } from './RingingDevices';

export class RingingLock {
    private locked = false;
    private forceLocked = false;
    private listeners: (() => void)[] = [];
    private pendingRings: Set<string> = new Set();

    isLocked() {
        return this.locked || this.forceLocked;
    }

    lock() {
        if (!this.locked) {
            this.locked = true;
            this.notifyListeners();
        }
    }

    unlock() {
        if (this.locked) {
            this.locked = false;
            this.notifyListeners();
        }
    }

    forceLock() {
        if (!this.forceLocked) {
            this.forceLocked = true;
            this.notifyListeners();
        }
    }

    forceUnlock() {
        if (this.forceLocked) {
            this.forceLocked = false;
            this.notifyListeners();
        }
    }

    addEventListener(listener: () => void) {
        this.listeners.push(listener);
    }

    addPendingRing(telephoneTag: string) {
        this.pendingRings.add(telephoneTag);
    }

    removePendingRing(telephoneTag: string) {
        this.pendingRings.delete(telephoneTag);
    }

    hasPendingRings(): boolean {
        return this.pendingRings.size > 0;
    }

    hasPendingTag(tag: string): boolean {
        return this.pendingRings.has(tag);
    }

    private notifyListeners() {
        for (const listener of this.listeners) {
            listener();
        }
    }
}

export class LockAwareRingingDevice implements RingingDevice {
    public tag: string;
    constructor(private underlying: RingingDevice, private lock: RingingLock) {
        lock.addEventListener(() => this.handleLockChange());
        this.tag = underlying.tag;
    }

    ringing() {
        if (!this.lock.isLocked()) {
            this.lock.forceLock();
            this.underlying.ringing();
        }
        this.lock.addPendingRing(this.tag);
    }

    stop(isTalking?: boolean) {
        this.lock.removePendingRing(this.tag);

        if (isTalking) {
            // only unlock when there are no pending rings
            if (!this.lock.hasPendingRings()) this.lock.forceUnlock();
            this.underlying.stop();
            return;
        }

        if (this.lock.isLocked() && this.lock.hasPendingRings()) { // Check for pending rings
            this.lock.forceUnlock();
            this.startRinging(); // Crucial: Restart ringing if pending calls exist
        } else {
            if (!this.lock.hasPendingRings()) {
                this.lock.forceUnlock();
            }
            this.lock.unlock(); // Only unlock when ALL calls are finished
            this.underlying.stop();
        }
    }


    private startRinging() {
        if (!this.lock.isLocked() && this.lock.hasPendingRings() && this.lock.hasPendingTag(this.tag)) {
            this.lock.lock();
            this.underlying.ringing();
        }
    }

    private handleLockChange() {
        if (!this.lock.isLocked() && this.lock.hasPendingRings()) {
            this.startRinging();
        }
    }
}
